import React, { useEffect } from "react";
import { useTheme } from "@tvg/design-system";
import { useEvents } from "@tvg/design-system/src/hooks/useEvents";
import { PicksSelectorCellContainer } from "./styled-components";

const PicksSelectorCellEventsContainer = (props: {
  columnNumber: number | null;
  selectedColumn: number | null;
  lineNumber: number | null;
  selectedLine: number | null;
  disabled: boolean;
  onSelectedCell: (line: number | null, column: number | null) => void;
  hasNextRaces: boolean;
  children: JSX.Element;
  isMatrix?: boolean;
  top?: boolean;
  side?: boolean;
  isHeader?: boolean;
}) => {
  const { events, hoverHandlers } = useEvents({});
  const theme = useTheme();

  useEffect(() => {
    if (
      events.isHovered &&
      props.onSelectedCell &&
      (props.hasNextRaces || props.columnNumber === 0)
    ) {
      props.onSelectedCell(props.lineNumber, props.columnNumber);
    }
  }, [events.isHovered]);

  return (
    // @ts-ignore
    <PicksSelectorCellContainer
      theme={theme}
      columnNumber={props.columnNumber}
      lineNumber={props.lineNumber}
      selectedColumn={props.selectedColumn}
      selectedLine={props.selectedLine}
      top={props.top}
      side={props.side}
      isMatrix={props.isMatrix}
      {...events}
      {...hoverHandlers}
      isHeader={props.isHeader}
    >
      {!props.disabled ? props.children : <></>}
    </PicksSelectorCellContainer>
  );
};

export default PicksSelectorCellEventsContainer;
